import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_MODULE,
  FETCH_MODULE_PROJECT_CLIENT_SERVICE,
  FETCH_MODULE_PROJECT_CLIENT_SERVICE_CLEAR,
  CHANGE_MODULE_STATUS,
  CHANGE_MODULE_STATUS_SUCCESS,
  CHANGE_MODULE_STATUS_FAILURE,
  SAVE_MODULE,
} from "./actionTypes";
import * as types from './actionTypes';
import {
  fetchModule,
  fetchModuleSuccess,
  fetchModuleFailure,
  fetchModuleProjectClientService,
  fetchModuleProjectClientServiceSuccess,
  fetchModuleProjectClientServiceFailure,
  fetchModuleProjectClientServiceClear,
  changeModuleStatus,
  changeModuleStatusSuccess,
  changeModuleStatusFailure,
  saveModuleSuccess,
  saveModuleFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Module
function* fetchModuleSaga(action) {
  try {
    // const formData = new FormData();
    // formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_MODULE, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put(fetchModuleSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchModuleFailure(error.message));
  }
}

function* fetchModuleProjectClientServiceSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_MODULE_PROJECT_CLIENT_SERVICE, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve client service dropdown data!");
    }
    yield put(fetchModuleProjectClientServiceSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchModuleProjectClientServiceFailure(error.message));
  }
}

function* fetchModuleProjectClientServiceClearSaga(action) {
  fetchModuleProjectClientServiceClear();
}

function* changeModuleStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_CHANGE_MODULE_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_MODULE_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_MODULE_STATUS_FAILURE, payload: error });
  }
}

// Create Module Saga
function* saveModuleSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_SAVE_MODULE, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Module saved successfully!",
      });
      yield put(saveModuleSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchModule(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(saveModuleFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the deduction",
    });
    yield put(saveModuleFailure(error.message));
  }
}

// Watcher Saga
function* timesheetSetupModuleSaga() {
  yield takeEvery(FETCH_MODULE, fetchModuleSaga);  
  yield takeEvery(FETCH_MODULE_PROJECT_CLIENT_SERVICE, fetchModuleProjectClientServiceSaga); 
  yield takeEvery(FETCH_MODULE_PROJECT_CLIENT_SERVICE_CLEAR, fetchModuleProjectClientServiceClearSaga);
  yield takeEvery(CHANGE_MODULE_STATUS, changeModuleStatusSaga);
  yield takeEvery(SAVE_MODULE, saveModuleSaga);
}

export default timesheetSetupModuleSaga;
